import React from "react";
import { Card, Row, Col, Typography, Grid } from "antd";
import {
  CreditCardOutlined,
  BankOutlined,
  SafetyOutlined,
  IdcardOutlined,
  GiftOutlined,
  WalletOutlined,
  DollarOutlined,
  MoneyCollectOutlined,
  SecurityScanOutlined,
  UserOutlined,
  TeamOutlined,
  CustomerServiceOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  ToolOutlined,
  FileTextOutlined,
  PhoneOutlined,
  MailOutlined,
  GlobalOutlined,
  LockOutlined,
  UnlockOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  StarOutlined,
  HeartOutlined,
  TrophyOutlined,
  CrownOutlined,
  FireOutlined,
  ThunderboltOutlined,
  RocketOutlined,
  BulbOutlined,
  BookOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  ShopOutlined,
  CarOutlined,
  CameraOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  SoundOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  StopOutlined,
  DownloadOutlined,
  UploadOutlined,
  ShareAltOutlined,
  LinkOutlined,
  CopyOutlined,
  SaveOutlined,
  ReloadOutlined,
  SyncOutlined,
  LoadingOutlined,
  SearchOutlined,
  FilterOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  KeyOutlined,
  DatabaseOutlined,
  CloudOutlined,
  WifiOutlined,
  MobileOutlined,
  TabletOutlined,
  DesktopOutlined,
  LaptopOutlined,
  PrinterOutlined,
  ScanOutlined,
  QrcodeOutlined,
  BarcodeOutlined,
  TagOutlined,
  TagsOutlined,
  FlagOutlined,
  PushpinOutlined,
  CompassOutlined,
  AimOutlined,
  SunOutlined,
  MoonOutlined,
  CloudSyncOutlined,
  CloudUploadOutlined,
  CloudDownloadOutlined,
  CloudServerOutlined,
} from "@ant-design/icons";
import type { Category, CategoryConfig } from "../types/category";
import { DEFAULT_CATEGORY_DATA } from "../types/categoryConstants";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

// 图标映射
const ICON_MAP: Record<string, React.ReactNode> = {
  CreditCardOutlined: <CreditCardOutlined />,
  BankOutlined: <BankOutlined />,
  SafetyOutlined: <SafetyOutlined />,
  IdcardOutlined: <IdcardOutlined />,
  GiftOutlined: <GiftOutlined />,
  WalletOutlined: <WalletOutlined />,
  DollarOutlined: <DollarOutlined />,
  MoneyCollectOutlined: <MoneyCollectOutlined />,
  SecurityScanOutlined: <SecurityScanOutlined />,
  UserOutlined: <UserOutlined />,
  TeamOutlined: <TeamOutlined />,
  CustomerServiceOutlined: <CustomerServiceOutlined />,
  QuestionCircleOutlined: <QuestionCircleOutlined />,
  SettingOutlined: <SettingOutlined />,
  ToolOutlined: <ToolOutlined />,
  FileTextOutlined: <FileTextOutlined />,
  PhoneOutlined: <PhoneOutlined />,
  MailOutlined: <MailOutlined />,
  GlobalOutlined: <GlobalOutlined />,
  LockOutlined: <LockOutlined />,
  UnlockOutlined: <UnlockOutlined />,
  CheckCircleOutlined: <CheckCircleOutlined />,
  CloseCircleOutlined: <CloseCircleOutlined />,
  ExclamationCircleOutlined: <ExclamationCircleOutlined />,
  StarOutlined: <StarOutlined />,
  HeartOutlined: <HeartOutlined />,
  TrophyOutlined: <TrophyOutlined />,
  CrownOutlined: <CrownOutlined />,
  FireOutlined: <FireOutlined />,
  ThunderboltOutlined: <ThunderboltOutlined />,
  RocketOutlined: <RocketOutlined />,
  BulbOutlined: <BulbOutlined />,
  BookOutlined: <BookOutlined />,
  CalendarOutlined: <CalendarOutlined />,
  ClockCircleOutlined: <ClockCircleOutlined />,
  EnvironmentOutlined: <EnvironmentOutlined />,
  HomeOutlined: <HomeOutlined />,
  ShopOutlined: <ShopOutlined />,
  CarOutlined: <CarOutlined />,
  CameraOutlined: <CameraOutlined />,
  PictureOutlined: <PictureOutlined />,
  VideoCameraOutlined: <VideoCameraOutlined />,
  SoundOutlined: <SoundOutlined />,
  PlayCircleOutlined: <PlayCircleOutlined />,
  PauseCircleOutlined: <PauseCircleOutlined />,
  StopOutlined: <StopOutlined />,
  DownloadOutlined: <DownloadOutlined />,
  UploadOutlined: <UploadOutlined />,
  ShareAltOutlined: <ShareAltOutlined />,
  LinkOutlined: <LinkOutlined />,
  CopyOutlined: <CopyOutlined />,
  SaveOutlined: <SaveOutlined />,
  ReloadOutlined: <ReloadOutlined />,
  SyncOutlined: <SyncOutlined />,
  LoadingOutlined: <LoadingOutlined />,
  SearchOutlined: <SearchOutlined />,
  FilterOutlined: <FilterOutlined />,
  SortAscendingOutlined: <SortAscendingOutlined />,
  SortDescendingOutlined: <SortDescendingOutlined />,
  EyeOutlined: <EyeOutlined />,
  EyeInvisibleOutlined: <EyeInvisibleOutlined />,
  KeyOutlined: <KeyOutlined />,
  DatabaseOutlined: <DatabaseOutlined />,
  CloudOutlined: <CloudOutlined />,
  WifiOutlined: <WifiOutlined />,
  MobileOutlined: <MobileOutlined />,
  TabletOutlined: <TabletOutlined />,
  DesktopOutlined: <DesktopOutlined />,
  LaptopOutlined: <LaptopOutlined />,
  PrinterOutlined: <PrinterOutlined />,
  ScanOutlined: <ScanOutlined />,
  QrcodeOutlined: <QrcodeOutlined />,
  BarcodeOutlined: <BarcodeOutlined />,
  TagOutlined: <TagOutlined />,
  TagsOutlined: <TagsOutlined />,
  FlagOutlined: <FlagOutlined />,
  PushpinOutlined: <PushpinOutlined />,
  CompassOutlined: <CompassOutlined />,
  AimOutlined: <AimOutlined />,
  SunOutlined: <SunOutlined />,
  MoonOutlined: <MoonOutlined />,
  CloudSyncOutlined: <CloudSyncOutlined />,
  CloudUploadOutlined: <CloudUploadOutlined />,
  CloudDownloadOutlined: <CloudDownloadOutlined />,
  CloudServerOutlined: <CloudServerOutlined />,
};

interface CategoryReplyPreviewProps {
  categoryData?: Category;
  onCategorySelect?: (config: CategoryConfig) => void;
  selectedCategory?: CategoryConfig;
}

const CategoryReplyPreview: React.FC<CategoryReplyPreviewProps> = ({
  categoryData,
  onCategorySelect,
  selectedCategory,
}) => {
  const screens = useBreakpoint();

  // 如果没有数据，显示默认示例
  const displayData = categoryData || DEFAULT_CATEGORY_DATA;

  const handleCategoryClick = (config: CategoryConfig) => {
    onCategorySelect?.(config);
  };

  const responsiveStyles = {
    container: {
      padding: 0,
      minHeight: "400px",
      display: "flex",
      flexDirection: "column" as const,
      justifyContent: "center",
      alignItems: "center",
    },
    contentContainer: {
      width: "100%",
      background: "transparent",
      padding: 0,
      margin: "0 auto",
    },
    title: {
      textAlign: "center" as const,
      marginBottom: "16px",
      color: "#1890ff",
      fontSize: screens.xs ? "24px" : "28px",
      fontWeight: 600,
    },
    subtitle: {
      textAlign: "left" as const,
      marginBottom: "32px",
      color: "#666",
      fontSize: screens.xs ? "14px" : "16px",
    },
    categoryCard: {
      cursor: "pointer",
      transition: "all 0.3s ease",
      height: "100%",
      minHeight: screens.xs ? "120px" : "160px",
      borderRadius: "12px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      background: "#fff",
    },
  };

  return (
    <div style={responsiveStyles.container}>
      <div style={responsiveStyles.contentContainer}>
        <Title level={2} style={responsiveStyles.title}>
          {displayData.title}
        </Title>

        <Text style={responsiveStyles.subtitle}>{displayData.desc}</Text>

        <Row gutter={[16, 16]}>
          {(displayData.configs || []).map((config, index) => {
            const isSelected = selectedCategory === config;
            const iconComponent = ICON_MAP[config.icon] || (
              <CreditCardOutlined />
            );

            return (
              <Col xs={24} sm={12} md={8} lg={8} xl={8} key={index}>
                <Card
                  hoverable
                  style={{
                    ...responsiveStyles.categoryCard,
                    border: isSelected
                      ? `2px solid ${config.color}`
                      : "1px solid #f0f0f0",
                    boxShadow: isSelected
                      ? `0 4px 20px ${config.color}30`
                      : "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                  bodyStyle={{
                    padding: screens.xs ? "20px 16px" : "28px 24px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    borderRadius: "12px",
                  }}
                  onClick={() => handleCategoryClick(config)}
                  onMouseEnter={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow = `0 8px 25px ${config.color}20`;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSelected) {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 2px 8px rgba(0,0,0,0.1)";
                    }
                  }}
                >
                  <div
                    style={{
                      fontSize: screens.xs ? "32px" : "40px",
                      color: config.color,
                      marginBottom: "12px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {iconComponent}
                  </div>

                  <Title
                    level={4}
                    style={{
                      margin: "0 0 8px 0",
                      color: isSelected ? config.color : "#262626",
                      fontSize: screens.xs ? "16px" : "18px",
                      fontWeight: 600,
                    }}
                  >
                    {config.name}
                  </Title>

                  <Text
                    style={{
                      color: "#8c8c8c",
                      fontSize: screens.xs ? "12px" : "14px",
                      lineHeight: "1.4",
                      marginBottom: "8px",
                    }}
                  >
                    {config.description}
                  </Text>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default CategoryReplyPreview;
